// eslint-disable-next-line @altermaind/you-shall-not-pass
import { SurveyTemplate } from '../state/types';

// eslint-disable-next-line @altermaind/you-shall-not-pass
export const en = {
  surveys: {
    pageTitle: 'Assessment',
    emptyStateNoPeople: {
      title: 'Soft skills assessment',
      titleHardSkills: 'Hard skills assessment',
      descriptionLine1: 'There are no profiles with complete information.',
      descriptionLine2:
        'To send the assessment, you must first register the company users in the !{CTA}! section.',
      ctaLabel: 'Profiles',
    },
    emptyStateNoCampaigns: {
      title: 'Soft skills assessment',
      descriptionLine1:
        'You have uploaded {{countPeople}} complete profiles eligible to receive the questionnaire, but you have not sent it yet.\nClick "!{SEND}!" to start collecting results on your company’s {{templateName}}.\nThe visibility settings for managers and employees can be modified after sending the assessment.',
      ctaLabel: 'Send assessment',
      alertBadge:
        'The model is undergoing scientific validation and shows a consistent level of reliability, especially in aggregated views by team and department',
      goToGuideCta: 'guide',
    },
    usefullInformations: {
      title: 'Useful materials',
      model: {
        title: 'Discover how the assessment works',
        description: 'Learn more about logic, scores,\nand criteria shaping the results.',
        buttonLabel: 'Go to guide',
      },
      boxTutorial: {
        title: 'Tutorial',
        description: 'Learn how to send the assessment and view the organization’s results',
        buttonLabel: 'Watch now',
      },
      simulation: {
        title: 'Run a simulation',
        description:
          'Try filling out the questionnaire and experience firsthand\nwhat your employees will see.',
        buttonLabel: 'Learn more',
      },
    },
    campaign: {
      setVisibilityDialog: {
        title: 'Manage result visibility',
        description:
          'Decide whether employees can view their assessment results immediately after completing it.',
        labelToggle: 'Result visibility',
        valueOnToggle: 'Active',
        valueOffToggle: 'Not active',
        persons: 'people',
        person: 'person',
        alert: {
          visibleWithResponses:
            'By disabling visibility, only administrators will have access to the results. Employees who have already viewed their results ({{totalCompletedResponses}}) will no longer be able to access them. Carefully consider this action to avoid confusion or unmet expectations.',
          hidden:
            'By enabling visibility, employees will be able to see their results directly from the homepage as soon as they complete the assessment. Enable this option only if you want the information to be immediately accessible.',
          visible:
            'By disabling visibility, only administrators will have access to the results. Make sure to keep this setting if you want to prevent employees from viewing the information.',
        },
        buttons: {
          cancel: 'Cancel',
          save: 'Save',
        },
      },
      reminderDialog: {
        title: 'Send reminder',
        description: {
          [SurveyTemplate.HardSkillAssessment]:
            'The reminder will be sent to {{pending}} users who are "Pending" and have not yet completed the hard skills assessment.',
          [SurveyTemplate.SoftSkillAssessment]:
            'The reminder will be sent to {{pending}} users who are "Pending" and have not yet completed the soft skills assessment.',
        },
        lastSendWarning:
          'The last reminder was sent !{BOLD}!: are you sure you want to send another one?',
        lastSendWarningBold: 'less than 48 hours ago',
        confirmMessage: 'Do you want to proceed with sending the reminder?',
        tabs: {
          summary: 'Summary',
          viewPeople: 'View people',
        },
        table: {
          name: 'Name',
          role: 'Role',
          mail: 'Email',
        },
        buttons: {
          cancel: 'Cancel',
          send: 'Send',
        },
        alert: 'Summary: {{total}} people will receive the reminder',
        unknownDepartment: 'Not assigned',
      },
      status: {
        notVisible: {
          title: 'Result sharing disabled',
          description:
            'Currently, assessment results will not be shown to employees. If you want them to view results after completion, change the visibility settings.',
        },
        visible: {
          title: 'Result sharing enabled',
          description:
            'Currently, assessment results are visible to employees after completion. If you want to restrict visibility, change the settings.',
        },
        cta: 'Manage visibility',
      },
      noData: 'No data to display',
      description: 'View analysis, department results, and insights for your organization',
      results: {
        title: 'Responses',
        description: 'Out of {{total}} assessments sent',
        completionRate: 'Completion rate',
        completed: 'Completed',
        notCompleted: 'Pending',
        viewResults: 'View results',
        sendReminder: 'Send reminder',
        alertLabel:
          'No results yet: the dashboard will be visible only after at least one response is collected',
      },
      coverage: {
        title: 'Assessments sent',
        description: 'Out of {{total}} valid profiles available',
        sendSurvey: 'Send assessment',
        totalSended: 'Sent',
        notSended: 'Not sent',
        completionRate: 'Coverage rate',
        alertLabel:
          'The assessment can only be sent to complete profiles. If some are incomplete, fix them in !{CTA}!.',
        ctaLabel: 'Profiles',
      },
    },
    sendSurvey: {
      title: 'Send {{templateName}} assessment',
      stepTemplates: {
        description: 'Choose an assessment',
        buttons: {
          continue: 'Continue',
        },
      },
      stepChooser: {
        description: 'Hi {{name}}! Who do you want to send the assessment to?',
        all: {
          title: 'Send to everyone',
          description: {
            single: '{{total}} person',
            plural: '{{total}} people',
          },
          descriptionHard: {
            single: "{{total}} person hasn't received the hard skills assessment yet",
            plural: "{{total}} people haven't received the hard skills assessment yet",
          },
          descriptionSoft: {
            single: "{{total}} person hasn't received the soft skills assessment yet",
            plural: "{{total}} people haven't received the soft skills assessment yet",
          },
        },
        departments: {
          title: 'Choose by department',
          description: 'Select specific departments',
        },
        employer: {
          title: 'Individual selection',
          description: 'Search and select profiles',
        },
        buttons: {
          back: 'Back',
        },
      },
      stepRecapAll: {
        title: '{{name}} Assessment',
        totalsSelected: 'Total recipients:',
        selectedDepartmentsLabel: 'Selected departments ({{count}}):',
        unknownDepartment: 'Not assigned',
        alertBadge: {
          label:
            '!{TOTAL_NEW_INVITED}! will receive an assessment for the first time. Sending it will activate their licenses. Based on your active subscription, !{SUBSCRIPTION_AMOUNT_NOTICE}!. Find more details about your plan in !{SETTINGS_LINK}!. Check the contract for further specifications.',
          totalInvited: '{{totalNewInvited}} recipients',
          subscriptionAmountNotice: 'your subscription amount may change',
          settingsLink: 'Settings / Plan',
        },
        description: 'Here’s the summary of your send',
        buttons: {
          back: 'Back',
          send: 'Send',
        },
      },
      stepListEmployees: {
        description: 'Search and select the specific people you want to include',
        descriptionForEmployeeOfDepartment:
          'If necessary, remove users from the departments before sending.',
        searchPlaceholder: 'Search by first or last name',
        buttons: {
          back: 'Back',
          continue: 'Continue',
        },
        table: {
          name: 'Name',
          email: 'Email',
          role: 'Role',
          department: 'Department',
          lastCompletedPeriod: 'Last completed questionnaire',
        },
      },
      stepRecapDepartments: {
        description:
          'Select the departments. Click on the departments you want to include.\nYou can select as many as you want.',
        manager: 'Manager: ',
        team: 'Team: ',
        unknownDepartment: 'Not assigned',
        buttons: {
          back: 'Back',
          continue: 'Continue',
          viewPeople: 'View people',
        },
        alert: {
          info: '!{TOTAL_SELECTED_DEPARTMENTS}! Total recipients: {{totalEmployees}} people',
          selectedDeparments: '{{totalDepartments}} departments selected:',
        },
      },
      stepLastConfirm: {
        description:
          'Sending the questionnaire starts the soft skills assessment, aiming to provide a clear picture of the organization’s strengths and development areas. Once sent, participants receive the invitation on the platform and after completion, results will be immediately available for employees and managers. Billing and credit allocation are also automatically activated.',
        buttons: {
          back: 'Back',
          confirm: 'Confirm',
        },
        sent: {
          title: 'Assessment sent!',
          description: {
            single: 'The {{templateName}} assessment was sent to {{count}} person.',
            plural: 'The {{templateName}} assessment was sent to {{count}} people.',
          },
          visibility: {
            title: 'Result sharing disabled',
            description:
              'Currently, assessment results will not be shown to employees. If you want them to view results after completion, change the visibility settings.',
            buttonLabel: 'Manage visibility',
          },
          isVisible: {
            title: 'Result sharing enabled',
            description:
              'Currently, assessment results are visible to employees after completion. If you want to restrict visibility, change the settings.',
            buttonLabel: 'Manage visibility',
          },
          saveVisibility: {
            description:
              'Decide whether employees can view their assessment results immediately after completing it.',
            labelToggle: 'Result visibility',
            alert:
              'By enabling visibility, employees will be able to see their results directly from the homepage as soon as they complete the assessment. Enable this option only if you want the information to be immediately accessible.',
          },
        },
      },
    },
    details: {
      stats: {
        title: 'Results',
        description: {
          label:
            'The data refers to organization users who have completed the questionnaire. The analysis base consists of {{count}}',
          single: 'user',
          plural: 'users',
        },
        tabs: {
          tab1: 'Organization',
          tab2: 'Departments',
        },
        tabOrganization: {
          title: 'Average score for {{currentName}}',
          description:
            'The chart shows average scores (scale 0-7) on the {{metricsCount}} {{currentName}}, considered essential for effectively facing AI challenges.',
          insignBox: {
            title: 'Insight',
            proTitle: 'Strengths',
            conTitle: 'Weaknesses',
          },
          downloadAnswerGuide: 'Download Answer Guide',
          distributionBox: {
            title: 'Score distribution by skill',
            description:
              'The distribution shows the percentage of users placed in the three competency levels for each skill.',
          },
        },
        tabDepartments: {
          distributionBox: {
            title: 'Response distribution by department',
            description:
              'The chart shows the number and percentage of users who completed the {{currentName}} questionnaire within each department.',
            goToDepartments:
              'Want more detailed analysis? Go to Departments and explore the department of interest',
            downloadAnswerGuide: 'Download Answer Guide',
          },
          distributionBySkillBox: {
            title: 'Score distribution by skill',
            description:
              'The distribution shows the percentage of department users placed in the three competency levels for each skill.',
          },
          overallBox: {
            title: 'Score comparison between departments',
            subTitle: 'Average score by department',
            description:
              'The chart compares the average scores (scale 0-7) of each department with the overall company average. It helps identify departments above or below the organizational average.',
            highValue: {
              title: 'Department with highest score in {{metric}}',
              score: 'Average score: ',
            },
            lowerValue: {
              title: 'Department with lowest score in {{metric}}',
              score: 'Average score: ',
            },
            tooltipValue: 'Score: ',
            tooltipTotal: 'Total people: ',
          },
          departments: {
            title: 'Learn more about departments',
            description: 'The department’s strength is the {{strength}} metric',
            viewDetails: 'Go to department',
            showMore: 'Show more',
            showLess: 'Show less',
          },
        },
      },
    },
    tutorial: {
      softSkills: {
        title: 'Manage the soft skills assessment',
        slides: {
          slide1: {
            title: 'Explore the assessment',
            description:
              'Try the assessment simulation: you can open the model to see how it’s structured and test it—a mode that lets you understand questions, duration, and results without saving data or affecting real metrics.',
          },
          slide2: {
            title: 'Send to recipients',
            description:
              'The assessment can only be sent to complete profiles. You can choose to send it to individual profiles, a department, or the entire organization.',
          },
          slide3: {
            title: 'Manage result visibility',
            description:
              'Decide whether employees can view their assessment results immediately after completing it. This setting can be changed anytime: you can choose to make results visible right away or analyze them internally before sharing. Note: if you hide results again after making them visible, employees who already viewed them will no longer have access.',
          },
          slide4: {
            title: 'Monitor progress',
            description:
              'After sending, you can monitor coverage and completion rates and send reminders to those who haven’t responded yet.',
          },
          slide5: {
            title: 'Take a look at the results',
            description:
              'Access the dashboard to view aggregated data: average organization scores and department overview. You’ll find average values (scale 0-7) for the 6 soft skills, level distributions, and insights on strengths and areas for improvement.',
          },
        },
      },
      hardSkills: {
        title: 'Manage the hard skills assessment',
        slides: {
          slide1: {
            title: 'Explore the assessment',
            description:
              'Try the assessment simulation: you can open the model to see how it’s structured and test it—a mode that lets you understand questions, duration, and results without saving data or affecting real metrics.',
          },
          slide2: {
            title: 'Send to recipients',
            description:
              'The assessment can only be sent to complete profiles. You can choose to send it to individual profiles, a department, or the entire organization.',
          },
          slide3: {
            title: 'Manage result visibility',
            description:
              'Decide whether employees can view their assessment results immediately after completing it. This setting can be changed anytime. Warning: if you hide results after making them visible, employees who already viewed them will no longer have access.',
          },
          slide4: {
            title: 'Monitor progress',
            description:
              'After sending, you can monitor coverage and completion rates and send reminders to those who haven’t responded yet.',
          },
          slide5: {
            title: 'Take a look at the results',
            description:
              'Access the dashboard to view aggregated data: average organization scores and department overview. You’ll find average values (scale 0-7) for the 4 hard skills, level distributions, and insights on strengths and areas for improvement.',
          },
        },
      },
    },
    hardSkills: {
      title: 'Your Hard Skills questionnaire is coming soon!',
      description:
        'We are preparing a tool to assess your technical skills.\nSoon you will be able to measure your Hard Skills just like you do with Soft Skills!',
      ctaLabel: 'Contact us to learn more',
    },
    simulate: {
      title: 'Assessment simulation',
      subtitle:
        'Try filling out the questionnaire to experience firsthand what your employees will see.',
      goBack: '{{templateName}} assessment',
      survey: {
        next: 'Next',
        back: 'Back',
        finish: 'End simulation',
      },
      intro: {
        title: '{{templateName}} assessment simulation',
        description:
          'With the {{templateName}} assessment simulation, you can experience what your collaborators will see: fill out the questionnaire, explore the sections, and get an example {{templateName}} profile.\n\nRemember that simulation data is not saved and you can repeat it as many times as you want. To generate your official profile, you must register your information and complete the questionnaire as an employee or manager.',
      },
      results: {
        title: 'Here is the simulation result!',
        description:
          'You have completed the simulation and this is the result of your {{templateName}}.',
        insights: {
          proTitle: 'Strengths',
          conTitle: 'Areas for improvement',
        },
      },
    },
  },
};
